import { DefaultState } from 'store/types';
import { DropdownItem } from 'store/types';

export const GET_STATUS_REQUEST = 'GET_STATUS_REQUEST';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_FAILURE = 'GET_STATUS_FAILURE';

export type GetStatusState = DefaultState & {
  contents?: DropdownItem[];
};

interface GetStatusRequest {
  type: typeof GET_STATUS_REQUEST;
}

interface GetStatusSuccess {
  type: typeof GET_STATUS_SUCCESS;
  contents: DropdownItem[];
}

interface GetStatusFailure {
  type: typeof GET_STATUS_FAILURE;
}

export type GetStatusActionTypes = GetStatusRequest | GetStatusSuccess | GetStatusFailure;